import React, { useState, useRef, useEffect } from "react"
import { Props_Timeline } from "./Timeline.props"
import { motion } from "framer-motion"
import { Legacy_CompileMarkdown } from '../../../../Shared/AttraxTs/React/ReactSnippetMDCompiler'

export const Timeline = (props: Props_Timeline) => {
    const { mainHeading, paragraph, repeatable_timelineItem } = props;

    // Track which timeline item is being hovered
    const [hoveredItem, setHoveredItem] = useState<number>(0);

    // Ref for positioning the dot correctly
    const timelineRef = useRef<HTMLDivElement>(null);
    const [dotPositions, setDotPositions] = useState<number[]>([]);

    // Calculate dot positions when component mounts
    useEffect(() => {
        if (timelineRef.current) {
            const itemElements = timelineRef.current.querySelectorAll('.attrax-timeline__item');
            const positions = Array.from(itemElements).map(el => {
                const rect = el.getBoundingClientRect();
                const containerRect = timelineRef.current!.getBoundingClientRect();
                return rect.top - containerRect.top + rect.height / 2;
            });
            setDotPositions(positions);
        }
    }, [repeatable_timelineItem.length]);

    return (
        <section className="attrax-timeline">
            <div className="attrax-timeline__container">
                {mainHeading.text?.value && (
                    <h2 className={`attrax-timeline__main-heading ${mainHeading.hideHeading?.value === 'hide' ? 'accessible-heading' : ''}`}>
                        {mainHeading.text.value}<span>{mainHeading.highlightedText.value}</span>
                    </h2>
                )}

                {paragraph.text?.value && (
                    <div className="attrax-timeline__paragraph">
                        {Legacy_CompileMarkdown(paragraph.text.value)}
                    </div>
                )}

                <div className="attrax-timeline__items-container" ref={timelineRef}>
                    <div className="attrax-timeline__line-container">
                        <div className="attrax-timeline__line"></div>
                        {dotPositions.length > 0 && (
                            <motion.div
                                className="attrax-timeline__dot"
                                initial={false}
                                animate={{
                                    top: `${dotPositions[hoveredItem]}px`
                                }}
                                transition={{ type: "spring", stiffness: 300, damping: 30 }}
                                aria-hidden="true"
                            ></motion.div>
                        )}
                    </div>

                    <div className="attrax-timeline__items">
                        {repeatable_timelineItem.map((item, index) => (
                            <div
                                className={`attrax-timeline__item ${hoveredItem === index ? 'attrax-timeline__item--active' : ''}`}
                                key={index}
                                onMouseEnter={() => setHoveredItem(index)}
                                onMouseLeave={() => setHoveredItem(index)}
                            >
                                <h3 className="attrax-timeline__year">
                                    {item.year?.value}
                                </h3>
                                <div className="attrax-timeline__content">
                                    <h4 className="attrax-timeline__item-heading">
                                        {item.heading?.value}
                                    </h4>
                                    <div className="attrax-timeline__item-text">
                                        {item.content?.value && Legacy_CompileMarkdown(item.content.value)}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};